import type { Meta, StoryObj } from "@storybook/react";

import type { StackProps } from "@/ui/layout";
import {
  Box,
  HStack as HStackComponent,
  VStack as VStackComponent,
} from "@/ui/layout";
import { ColorToken } from "@/ui/theme/tokens";

const StoryMeta: Meta<StackProps> = {
  title: "Layout/Stacks",
  argTypes: {
    accessibilityLabel: { control: "text" },
    gap: { control: "number" },
    testID: { control: "text" },
  },
  args: {
    accessibilityLabel: "Stack Container",
    gap: 10,
    testID: "storybook",
  },
};

type Story = StoryObj<StackProps>;

// eslint-disable-next-line max-params
const stackChildren = Array.from({ length: 5 }).map((_, index) => (
  <Box
    backgroundColor={ColorToken.Primary100}
    height={50}
    // eslint-disable-next-line react/no-array-index-key
    key={index}
    width={50}
  />
));

const HStack: Story = {
  render: (args) => {
    return <HStackComponent {...args}>{stackChildren}</HStackComponent>;
  },
};

const VStack: Story = {
  render: (args) => {
    return <VStackComponent {...args}>{stackChildren}</VStackComponent>;
  },
};

export { HStack, VStack };
export default StoryMeta;
